import { useEffect, useState } from 'react';
import BlockCreationLink from './BlockCreationLink';
import imageScenario from '/src/features/editor/image/scenario2.svg';
import imageAction from '/src/features/editor/image/action.svg';
import imagePropos from '/src/features/editor/image/propos.svg';
import imageMagic from '/src/features/editor/image/magic.svg';
import iconAnnouncement from '/src/features/editor/image/announce.png';
import './ZoneBlockCreation.css';
import useShiftKey from '../../../hook/useShiftKey';
// Create a zone for choosing witch block's you want to create in the editor : action, statement, scenario, propos
function ZoneBlockCreation ( {position, showing, setShowing}) {

    const [show, setShow] = useState(false);

    const { changeShiftKey, shiftKey } = useShiftKey();

    const onMouseEnter = () => {
        shiftKey ? changeShiftKey() : null;
        setShow(true);
    }

    const hideZone = () => {
        setShow(false)
        if (setShowing) {
            setShowing(false)
        }
    }
    const offset = {
        x : parseFloat(position?.left) - 120, // coordonees trouvee a tatons
        y : parseFloat(position?.top) - 80
    }
    if (showing) {
        shiftKey ? changeShiftKey() : null;
    }
    const hasShortcut = showing == true && position != null

    useEffect(() =>{
        setShow(showing);
    }, [showing])

    return (
        <>
            <div className={"create_block " + (show == false ? "" : "highlighted")} onMouseEnter={onMouseEnter} ></div>
            {show &&
            <section id="zone_block_creation" >
                <section className="content" style={ showing ? position : null} onMouseLeave={() => showing == true ? null : hideZone()}>
                    <label className="txt1">New Block</label>
                    <label className="txt2">Choose a block to create</label>
                    <i className="fas fa-puzzle-piece icon"></i>
                    <BlockCreationLink className="scenario" label="Scenario" image={imageScenario} onClose={() => hideZone()} position={position ? offset : null} shortcut={hasShortcut ? {title : "1" , value :"49"} : ""}/>
                    <BlockCreationLink className="propos" label="Statement" image={imagePropos} onClose={() => hideZone()} position={position ? offset : null} shortcut={hasShortcut ? {title : "2" , value :"50"} : ""}/>
                    <BlockCreationLink className="action" label="Action" image={imageAction} onClose={() => hideZone()} position={position ? offset : null} shortcut={hasShortcut ? {title : "3" , value :"51"} : ""}/>
                    <BlockCreationLink className="magic" label="Jump" image={imageMagic} onClose={() => hideZone()} position={position ? offset : null} shortcut={hasShortcut ? {title : "4" , value :"52"} : ""}/>
                    <BlockCreationLink className="announcement" label="Announcement" image={iconAnnouncement} onClose={() => hideZone()} position={position ? offset : null} shortcut={hasShortcut ? {title : "5" , value :"53"} : ""}/>

                </section>
            </section>
            }
        </>
    )
}

export default ZoneBlockCreation;
